import { Box, Typography } from "@mui/material";
import DisplayLabel from "./base-components/Label";

const DisplayLocation = ({ label, value }) => {
  return (
    <Box className=" cursor-pointer hover:opacity-75 transition-opacity">
      <DisplayLabel text={label} />
      <Typography variant="h4">{value}</Typography>
    </Box>
  );
};

export default DisplayLocation;
